var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLocationMarkerSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 6,
  height: 10,
  viewBox: "0 0 6 10",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M3 0c1.657 0 3 1.433 3 3.2q0 .463-.117.888C5.959 4.033 3.375 10 3.375 10h-.75S.041 4.033.117 4.088A3.4 3.4 0 0 1 0 3.2C0 1.433 1.343 0 3 0m1 2.985Q3.993 2 3 2 2 2 2 3t1 1 1-1z"
})));
export default SvgLocationMarkerSm;